import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  select: {
    minWidth: '80px',
    width: '100%',
    maxWidth: '100%',
    [`> svg`]: {
      marginRight: '4px',
    },
    '& .MuiSelect-select': {
      width: '100%',
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: '12px',
      paddingRight: '32px',
    },
  },
  sexSelect: {
    minWidth: '60px',
    width: '100%',
    maxWidth: '100%',
    '& .MuiSelect-select': {
      width: '100%',
      maxWidth: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: '8px 32px 8px 12px',
    },
  },
  voiceSelect: {
    minWidth: '100px',
    width: '100%',
    maxWidth: '100%',
    [`> svg`]: {
      marginRight: '4px',
    },
    '& .MuiSelect-select': {
      width: '100%',
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: '42px',
      paddingRight: '32px',
    },
  },
  voiceContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
  },
  voiceSelectWrapper: {
    flex: 1,
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
  },
  voiceIcon: {
    position: 'absolute',
    zIndex: 999,
    left: '24px',
    borderRadius: '50%',
    padding: '5px',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    transition: 'all 0.3s ease',
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(1)',
        opacity: 1,
      },
      '50%': {
        transform: 'scale(1.1)',
        opacity: 0.8,
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 1,
      },
    },
  },
  cancel_button: {
    display: 'flex',
    alignItems: 'center',
    height: '36px',
    width: '36px',
    padding: '10px',
    background: theme.palette.extendedGrey?.lightest,
    borderRadius: '8px',
  },
  save_button: {
    display: 'flex',
    alignItems: 'center',
    height: '36px',
    width: '36px',
    padding: '10px',
    background: theme.palette.primary.dark,
    borderRadius: '8px',
    '&:disabled': {
      opacity: 0.4,
    },
  },
  save_button_shake: {
    animation: '$saveAttention 0.65s cubic-bezier(0.34, 1.56, 0.64, 1)',
  },
  '@keyframes saveAttention': {
    '0%': { transform: 'translateX(0) scale(1)', boxShadow: '0 0 0 rgba(250, 137, 107, 0)' },
    '18%': {
      transform: 'translateX(-5px) scale(1.04)',
      boxShadow: '0 0 0 4px rgba(250, 137, 107, 0.18)',
    },
    '36%': { transform: 'translateX(5px) scale(1.06)' },
    '54%': { transform: 'translateX(-3px) scale(1.03)' },
    '72%': { transform: 'translateX(3px) scale(1.01)' },
    '100%': { transform: 'translateX(0) scale(1)', boxShadow: '0 0 0 rgba(250, 137, 107, 0)' },
  },
  sexCellCustom: {
    paddingRight: '12px',
  },
  voiceCellCustom: {
    paddingLeft: '12px',
  },
  maleIcon: {
    fontSize: 22,
    color: '#2196F3',
  },
  femaleIcon: {
    fontSize: 22,
    color: '#E91E63',
  },
  genderSelectContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
  },
  selectMenuItemContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '8px',
    width: '100%',
  },
  voiceIconPlaying: {
    backgroundColor: '#4CAF50',
    '&:hover': {
      backgroundColor: '#45A049',
    },
  },
  voiceIconWithPreview: {
    backgroundColor: '#7C8FAC',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#6A7A94',
    },
  },
  voiceIconNoPreview: {
    backgroundColor: '#9E9E9E',
    cursor: 'not-allowed',
  },
  voiceIconDisabled: {
    opacity: 0.5,
  },
  voiceIconAnimated: {
    animation: 'pulse 1.5s ease-in-out infinite',
  },
  volumeIcon: {
    fontSize: 18,
    color: 'white',
  },
  fieldErrorText: {
    color: theme.palette.error.main,
    fontSize: 12,
    marginTop: 4,
    marginLeft: 2,
    lineHeight: 1.2,
    minHeight: 18,
  },
  fieldHintText: {
    color: theme.palette.warning.main,
    fontSize: 12,
    marginTop: 4,
    marginLeft: 2,
    lineHeight: 1.2,
    minHeight: 18,
  },
}));
